var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_1324)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1399_1324",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H32V32H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1399_1324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 20.4375H6.03312C6.7235 20.4375 7.28312 20.9971 7.28312 21.6875V29.8125C7.28312 30.5029 6.7235 31.0625 6.03312 31.0625H2.1875C1.49712 31.0625 0.9375 30.5029 0.9375 29.8125V21.6875C0.9375 20.9971 1.49712 20.4375 2.1875 20.4375Z",
    stroke: "#131313",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.283 21.6875C9.37163 20.1837 12.174 20.1333 14.3154 21.5609L14.5054 21.6875H19.5053C20.5409 21.6875 21.3803 22.527 21.3803 23.5625C21.3803 24.598 20.5409 25.4375 19.5054 25.4375H13.8804H19.9751C20.9049 25.4375 21.8015 25.0921 22.491 24.4683L28.3353 19.1806C28.9802 18.5971 29.9694 18.6218 30.5843 19.2368C31.2051 19.8575 31.2236 20.8581 30.6262 21.5014L24.3916 28.2149C23.4456 29.2336 22.1181 29.8125 20.7278 29.8125H7.283V21.6875Z",
    stroke: "#131313",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6286 1.9072L26.4527 14.2758C27.1422 15.5255 26.2382 17.0566 24.811 17.0566H11.1629C9.73561 17.0566 8.83168 15.5255 9.52111 14.2758L16.3452 1.9072C17.0582 0.61489 18.9156 0.61489 19.6286 1.9072Z",
    stroke: "#131313",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9843 10.1816V6.11914",
    stroke: "#131313",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9218 13.3066C18.9218 13.8244 18.5021 14.2441 17.9843 14.2441C17.4666 14.2441 17.0468 13.8244 17.0468 13.3066C17.0468 12.7888 17.4666 12.3691 17.9843 12.3691C18.5021 12.3691 18.9218 12.7888 18.9218 13.3066Z",
    fill: "#131313"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_1324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.fa3f4aae04a6eb62f85d96b77ed58232.svg";
export { ForwardRef as ReactComponent };